// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__2srta"};